import React from 'react';
import ReactCookieConsent from 'react-cookie-consent';

export default function CookieConsent() {
  return (
    <ReactCookieConsent
      location='bottom'
      buttonText='Okay'
      cookieName='gatsby-plugin-google-analytics-gdpr_cookies-enabled'
      style={{
        background:
          'linear-gradient(to right, orange , yellow, green, cyan, blue, violet)',
        fontWeight: 'bold',
        color: '#000000',
      }}
      buttonStyle={{
        color: '#000000',
        background: 'linear-gradient(to left, green, cyan)',
        fontSize: '13px',
        fontWeight: 'bold',
      }}
      expires={150}
      flipButtons
      onAccept={() => {
        console.log('Accept was triggered by clicking the Accept button');
      }}
      enableDeclineButton
      onDecline={() => {
        console.log('No delicious cookies for me');
      }}
    >
      We use fresh-baked cookies to enhance your experience, including Google
      Analytics. Declining cookies will remove YouTube content.
    </ReactCookieConsent>
  );
}
